import React, { FC, ReactNode } from "react"
import { AuthProvider } from "react-oidc-context"
import { oidcConfig } from "../../../services/oidc/oidcConfig"

interface IOIDCProviderProps {
  children: ReactNode
}

export const OIDCProvider: FC<IOIDCProviderProps> = ({ children }) => {
  const onSigninCallback = () => {
    // Redirect to the home page after successful sign-in
    window.history.replaceState({}, document.title, window.location.pathname)
  }

  const onSignoutCallback = () => {
    // Clear any application state after sign-out
    console.log("User signed out successfully")
  }

  const onRemoveUser = () => {
    // Clear any application state when user is removed
    console.log("User removed")
  }

  return (
    <AuthProvider
      {...oidcConfig}
      onSigninCallback={onSigninCallback}
      onSignoutCallback={onSignoutCallback}
      onRemoveUser={onRemoveUser}
    >
      {children}
    </AuthProvider>
  )
}
